import {
  ValidatableTextField,
  ValidatableTextFieldProps,
} from "@/components/auth/ValidatableTextField";

export function OrgValidatableTextField({
  sx,
  ...props
}: ValidatableTextFieldProps) {
  return (
    <ValidatableTextField
      fullWidth
      sx={{
        "& .MuiFormControl-root": {
          height: "60px !important",
          "& .MuiInputBase-root": { height: "60px" },
          "& .MuiInputLabel-root:not(.Mui-focused):not(.MuiInputLabel-shrink)":
            {
              color: "#A3A3A3",
            },
        },
        ...(sx as any),
      }}
      {...props}
    />
  );
}
